// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/components/UserMenu/ProfileModal.css */

/* ============================================
   PROFILE MODAL
   ============================================ */

.profile-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-md);
  animation: profile-overlay-fade-in 0.2s ease-out;
}

@keyframes profile-overlay-fade-in {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.profile-modal {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 380px;
  max-height: 90vh;
  overflow-y: auto;
  animation: profile-modal-slide-up 0.25s ease-out;
  display: flex;
  flex-direction: column;
}

@keyframes profile-modal-slide-up {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ---- Header ---- */
.profile-modal__header {
  padding: var(--space-lg) var(--space-lg) var(--space-sm);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-border);
}

.profile-modal__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.profile-modal__title-icon {
  font-size: var(--font-size-xl);
}

.profile-modal__close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  font-size: var(--font-size-lg);
  color: var(--color-text-light);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
}

.profile-modal__close:hover {
  background-color: var(--color-progress-bg);
  color: var(--color-text-primary);
}

/* ---- Body ---- */
.profile-modal__body {
  padding: var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

/* ---- Avatar Section ---- */
.profile-modal__avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-sm);
}

.profile-modal__avatar {
  width: 64px;
  height: 64px;
  border-radius: var(--radius-full);
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-extrabold);
  flex-shrink: 0;
}

.profile-modal__email {
  font-size: var(--font-size-sm);
  color: var(--color-text-light);
  word-break: break-all;
  text-align: center;
}

.profile-modal__verified-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
  padding: 2px var(--space-sm);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
}

.profile-modal__verified-badge--yes {
  background-color: rgba(76, 175, 80, 0.1);
  color: var(--color-success);
}

.profile-modal__verified-badge--no {
  background-color: rgba(255, 143, 0, 0.1);
  color: var(--color-accent);
}

/* ---- Form Section ---- */
.profile-modal__form {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.profile-modal__field {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.profile-modal__label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
}

.profile-modal__input {
  padding: var(--space-sm) var(--space-md);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background-color: var(--color-card-white);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  appearance: none;
  font-family: inherit;
}

.profile-modal__input:focus {
  outline: none;
  border-color: var(--color-wood-medium);
  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);
}

.profile-modal__input::placeholder {
  color: var(--color-text-light);
}

.profile-modal__input--readonly {
  background-color: var(--color-progress-bg);
  color: var(--color-text-light);
  cursor: not-allowed;
}

.profile-modal__save-btn {
  width: 100%;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  border: none;
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  box-shadow: var(--shadow-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
}

.profile-modal__save-btn:hover:not(:disabled) {
  background-color: var(--color-wood-dark);
}

.profile-modal__save-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.profile-modal__save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.profile-modal__save-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: profile-spin 0.6s linear infinite;
}

@keyframes profile-spin {
  to { transform: rotate(360deg); }
}

/* ---- Toast / Success Message ---- */
.profile-modal__toast {
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  text-align: center;
  animation: profile-toast-pop 0.3s ease-out;
}

.profile-modal__toast--success {
  background-color: rgba(76, 175, 80, 0.1);
  border: 1.5px solid var(--color-success);
  color: var(--color-success);
}

.profile-modal__toast--error {
  background-color: rgba(229, 57, 53, 0.08);
  border: 1.5px solid var(--color-error);
  color: var(--color-error);
}

@keyframes profile-toast-pop {
  0% { opacity: 0; transform: translateY(4px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* ---- Account Info ---- */
.profile-modal__info-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.profile-modal__info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
}

.profile-modal__info-value {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
}

/* ---- Danger Zone ---- */
.profile-modal__danger-zone {
  border-top: 1px solid var(--color-border);
  padding-top: var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.profile-modal__danger-title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--color-error);
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.profile-modal__danger-description {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
  line-height: var(--line-height-normal);
}

.profile-modal__delete-btn {
  width: 100%;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  border: 2px solid var(--color-error);
  background-color: transparent;
  color: var(--color-error);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
}

.profile-modal__delete-btn:hover:not(:disabled) {
  background-color: var(--color-error);
  color: white;
}

.profile-modal__delete-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.profile-modal__delete-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ---- Delete Confirmation ---- */
.profile-modal__delete-confirm {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  padding: var(--space-md);
  background-color: rgba(229, 57, 53, 0.04);
  border: 1.5px solid var(--color-error);
  border-radius: var(--radius-md);
  animation: profile-toast-pop 0.2s ease-out;
}

.profile-modal__delete-confirm-icon {
  font-size: 2rem;
  text-align: center;
}

.profile-modal__delete-confirm-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-error);
  text-align: center;
}

.profile-modal__delete-confirm-message {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  text-align: center;
  line-height: var(--line-height-normal);
}

.profile-modal__delete-confirm-input {
  padding: var(--space-sm) var(--space-md);
  border: 1.5px solid var(--color-error);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background-color: var(--color-card-white);
  font-family: inherit;
  text-align: center;
}

.profile-modal__delete-confirm-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.15);
}

.profile-modal__delete-confirm-actions {
  display: flex;
  gap: var(--space-sm);
}

.profile-modal__delete-confirm-btn {
  flex: 1 1;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
}

.profile-modal__delete-confirm-btn--cancel {
  background-color: var(--color-progress-bg);
  color: var(--color-text-secondary);
}

.profile-modal__delete-confirm-btn--cancel:active {
  background-color: var(--color-border);
}

.profile-modal__delete-confirm-btn--confirm {
  background-color: var(--color-error);
  color: white;
  box-shadow: var(--shadow-sm);
}

.profile-modal__delete-confirm-btn--confirm:active:not(:disabled) {
  opacity: 0.85;
}

.profile-modal__delete-confirm-btn--confirm:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/UserMenu/ProfileModal.css"],"names":[],"mappings":"AAAA,kGAAkG;;AAElG;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gDAAgD;AAClD;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,wDAAwD;EACxD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;EAC1C,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,yCAAyC;EACzC,kFAAkF;EAElF,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,YAAY;EACZ,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,sCAAsC;AACtC;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,KAAK,UAAU,EAAE,0BAA0B,EAAE;EAC7C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,yCAAyC;EACzC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,yCAAyC;EACzC,sCAAsC;EACtC,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/components/UserMenu/ProfileModal.css */\n\n/* ============================================\n   PROFILE MODAL\n   ============================================ */\n\n.profile-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 200;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-md);\n  animation: profile-overlay-fade-in 0.2s ease-out;\n}\n\n@keyframes profile-overlay-fade-in {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n.profile-modal {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 380px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: profile-modal-slide-up 0.25s ease-out;\n  display: flex;\n  flex-direction: column;\n}\n\n@keyframes profile-modal-slide-up {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ---- Header ---- */\n.profile-modal__header {\n  padding: var(--space-lg) var(--space-lg) var(--space-sm);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.profile-modal__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.profile-modal__title-icon {\n  font-size: var(--font-size-xl);\n}\n\n.profile-modal__close {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  font-size: var(--font-size-lg);\n  color: var(--color-text-light);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n}\n\n.profile-modal__close:hover {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-primary);\n}\n\n/* ---- Body ---- */\n.profile-modal__body {\n  padding: var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-lg);\n}\n\n/* ---- Avatar Section ---- */\n.profile-modal__avatar-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.profile-modal__avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: var(--radius-full);\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-extrabold);\n  flex-shrink: 0;\n}\n\n.profile-modal__email {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-light);\n  word-break: break-all;\n  text-align: center;\n}\n\n.profile-modal__verified-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-xs);\n  padding: 2px var(--space-sm);\n  border-radius: var(--radius-full);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n}\n\n.profile-modal__verified-badge--yes {\n  background-color: rgba(76, 175, 80, 0.1);\n  color: var(--color-success);\n}\n\n.profile-modal__verified-badge--no {\n  background-color: rgba(255, 143, 0, 0.1);\n  color: var(--color-accent);\n}\n\n/* ---- Form Section ---- */\n.profile-modal__form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n.profile-modal__field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.profile-modal__label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n}\n\n.profile-modal__input {\n  padding: var(--space-sm) var(--space-md);\n  border: 1.5px solid var(--color-border);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background-color: var(--color-card-white);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n  -webkit-appearance: none;\n  appearance: none;\n  font-family: inherit;\n}\n\n.profile-modal__input:focus {\n  outline: none;\n  border-color: var(--color-wood-medium);\n  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);\n}\n\n.profile-modal__input::placeholder {\n  color: var(--color-text-light);\n}\n\n.profile-modal__input--readonly {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-light);\n  cursor: not-allowed;\n}\n\n.profile-modal__save-btn {\n  width: 100%;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  border: none;\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n}\n\n.profile-modal__save-btn:hover:not(:disabled) {\n  background-color: var(--color-wood-dark);\n}\n\n.profile-modal__save-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.profile-modal__save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.profile-modal__save-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: profile-spin 0.6s linear infinite;\n}\n\n@keyframes profile-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ---- Toast / Success Message ---- */\n.profile-modal__toast {\n  padding: var(--space-sm) var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  text-align: center;\n  animation: profile-toast-pop 0.3s ease-out;\n}\n\n.profile-modal__toast--success {\n  background-color: rgba(76, 175, 80, 0.1);\n  border: 1.5px solid var(--color-success);\n  color: var(--color-success);\n}\n\n.profile-modal__toast--error {\n  background-color: rgba(229, 57, 53, 0.08);\n  border: 1.5px solid var(--color-error);\n  color: var(--color-error);\n}\n\n@keyframes profile-toast-pop {\n  0% { opacity: 0; transform: translateY(4px); }\n  100% { opacity: 1; transform: translateY(0); }\n}\n\n/* ---- Account Info ---- */\n.profile-modal__info-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.profile-modal__info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n}\n\n.profile-modal__info-value {\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n}\n\n/* ---- Danger Zone ---- */\n.profile-modal__danger-zone {\n  border-top: 1px solid var(--color-border);\n  padding-top: var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.profile-modal__danger-title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-error);\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.profile-modal__danger-description {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n  line-height: var(--line-height-normal);\n}\n\n.profile-modal__delete-btn {\n  width: 100%;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  border: 2px solid var(--color-error);\n  background-color: transparent;\n  color: var(--color-error);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n}\n\n.profile-modal__delete-btn:hover:not(:disabled) {\n  background-color: var(--color-error);\n  color: white;\n}\n\n.profile-modal__delete-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.profile-modal__delete-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ---- Delete Confirmation ---- */\n.profile-modal__delete-confirm {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  padding: var(--space-md);\n  background-color: rgba(229, 57, 53, 0.04);\n  border: 1.5px solid var(--color-error);\n  border-radius: var(--radius-md);\n  animation: profile-toast-pop 0.2s ease-out;\n}\n\n.profile-modal__delete-confirm-icon {\n  font-size: 2rem;\n  text-align: center;\n}\n\n.profile-modal__delete-confirm-title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-error);\n  text-align: center;\n}\n\n.profile-modal__delete-confirm-message {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  text-align: center;\n  line-height: var(--line-height-normal);\n}\n\n.profile-modal__delete-confirm-input {\n  padding: var(--space-sm) var(--space-md);\n  border: 1.5px solid var(--color-error);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background-color: var(--color-card-white);\n  font-family: inherit;\n  text-align: center;\n}\n\n.profile-modal__delete-confirm-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.15);\n}\n\n.profile-modal__delete-confirm-actions {\n  display: flex;\n  gap: var(--space-sm);\n}\n\n.profile-modal__delete-confirm-btn {\n  flex: 1;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n}\n\n.profile-modal__delete-confirm-btn--cancel {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-secondary);\n}\n\n.profile-modal__delete-confirm-btn--cancel:active {\n  background-color: var(--color-border);\n}\n\n.profile-modal__delete-confirm-btn--confirm {\n  background-color: var(--color-error);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.profile-modal__delete-confirm-btn--confirm:active:not(:disabled) {\n  opacity: 0.85;\n}\n\n.profile-modal__delete-confirm-btn--confirm:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
